import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../styles/Sidebar.css";

const Sidebar = ({ handleAdminLogout }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  // Toggle sidebar open/close on mobile
  const toggleSidebar = () => {
    setIsOpen((prev) => !prev);
  };

  // When a link is clicked on mobile, close the sidebar
  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <div className="sidebar-container">
      {/* Toggle button visible on mobile */}
      <button className="sidebar-toggle" onClick={toggleSidebar}>
        {isOpen ? "✖" : "☰"}
      </button>
      <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
        <h2>Admin Panel</h2>
        <ul>
          <li>
            <NavLink to="/admin/dashboard" onClick={handleLinkClick}>
              Dashboard
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/products" onClick={handleLinkClick}>
              Products
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/orders" onClick={handleLinkClick}>
              Orders
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/customers" onClick={handleLinkClick}>
              Customers
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/categories" onClick={handleLinkClick}>
              Categories
            </NavLink>
          </li>
          <li>
            <button
              className="logout-btn"
              onClick={() => {
                handleAdminLogout();
                navigate("/adminlogin");
              }}
            >
              Logout Admin
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
